export const MISTAKE_BOOK_PRACTICE_SETS_PATH =
  "/practice/mistake-book/practice-sets";

export const MISTAKE_BOOK_PRACTICE_SETS_ANALYTICS_PATH =
  "/practice/mistake-book/practice-sets/analytics";
